import { render, staticRenderFns } from "./tab-open.vue?vue&type=template&id=7bb03d08"
import script from "./tab-open.vue?vue&type=script&lang=js"
export * from "./tab-open.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports